const OnboardStatus = {
  OnBoardNow: "now",
  OnBoardLater: "later",
};

export default OnboardStatus;
